import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import GridTable from "../../../../common/components/core/GridTable";
import {useInvoiceOrdersGridContext} from '../InvoiceOrdersGridContext';
import styles from './InvoiceOrdersGrid.module.scss';

const InvoiceOrdersGrid = () => {
  const {infiniteScroll, table} = useInvoiceOrdersGridContext();

  return (
    <div id={infiniteScroll.containerID} className={styles.scrollContainer}>
      <InfiniteScroll {...infiniteScroll.props} height={648}>
        <GridTable table={table} />
      </InfiniteScroll>
    </div>
  )
};

export default InvoiceOrdersGrid;
